import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

const LOGIN_PROMPT_DELAY = 2000; // 2 seconds
const LOGIN_PROMPT_SHOWN_KEY = 'login-prompt-shown';

export function useLoginPrompt() {
  const { user } = useAuth();
  const location = useLocation();
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Don't show prompt if user is logged in
    if (user) {
      return;
    }

    // Don't show prompt on tutorials pages
    if (location.pathname.startsWith('/tutorials')) {
      return;
    }

    // Don't show prompt on landing pages
    if (location.pathname === '/grow' || location.pathname === '/grow-box') {
      return;
    }

    // Check if prompt has been shown before
    const hasShownPrompt = sessionStorage.getItem(LOGIN_PROMPT_SHOWN_KEY);
    if (hasShownPrompt) {
      return;
    }

    // Show prompt after delay
    const timer = setTimeout(() => {
      setShowPrompt(true);
    }, LOGIN_PROMPT_DELAY);

    return () => clearTimeout(timer);
  }, [user, location.pathname]);

  const closePrompt = () => {
    setShowPrompt(false);
    sessionStorage.setItem(LOGIN_PROMPT_SHOWN_KEY, 'true');
  };

  return { showPrompt, closePrompt };
}